<script lang="ts">
import { AppFormatUnitComponent } from "./app-format-unit.ts";
export default AppFormatUnitComponent;
</script>

<template>
    {{ formattedValue }}
</template>
